import React from "react";
import { EmergencyContact } from "../../../types/types";

export const emptyEmergencyContact = (): EmergencyContact => ({
  firstName: "",
  lastName: "",
  relationship: "",
  mobileNumber: "",
  email: "",
});

export const hasCompleteEmergencyContact = (
  contact?: EmergencyContact | null,
) =>
  Boolean(
    contact?.firstName.trim() &&
      contact.lastName.trim() &&
      contact.relationship.trim() &&
      (contact.mobileNumber?.trim() || contact.email?.trim()),
  );

interface EmergencyContactCardProps {
  value?: EmergencyContact | null;
  onChange: (value: EmergencyContact) => void;
  required?: boolean;
}

export default function EmergencyContactCard({
  value,
  onChange,
  required = false,
}: EmergencyContactCardProps) {
  const contact = value ?? emptyEmergencyContact();
  const update = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...contact, [event.target.name]: event.target.value });
  };

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">Emergency Contact</div>
        <div className="field-hint">
          This is contact information only and does not create a party or service member.
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">First Name {required ? "*" : ""}</label>
          <input className="form-input" name="firstName" value={contact.firstName} onChange={update} />
        </div>
        <div className="form-group">
          <label className="form-label">Last Name {required ? "*" : ""}</label>
          <input className="form-input" name="lastName" value={contact.lastName} onChange={update} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Relationship {required ? "*" : ""}</label>
          <input className="form-input" name="relationship" value={contact.relationship} onChange={update} />
        </div>
        <div className="form-group">
          <label className="form-label">Mobile Number {required ? "*" : ""}</label>
          <input className="form-input" name="mobileNumber" value={contact.mobileNumber ?? ""} onChange={update} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-input" type="email" name="email" value={contact.email ?? ""} onChange={update} />
        </div>
      </div>
    </div>
  );
}
